var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex md:flex-row flex-col w-full items-center justify-center gap-4"},[(_vm.withLogo)?_c('Logo',{staticClass:"h-12"}):_vm._e(),_c('h1',{staticClass:"text-white text-opacity-80 font-base uppercase leading-normal text-center tracking-widest",class:[
      'text-xl ',
      'sm:text-2xl',
      'md:text-3xl',
      'lg:text-4xl',
      'xl:text-5xl' ]},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }